import { DashboardCards } from "@/components/DashboardCards";

export function Dashboard() {
  return (
    <div>
      <div className="flex h-14 items-center rounded-b-2xl bg-[#16A34A] bg-opacity-40 px-10">
        <h3 className="p-5 font-Hemmers text-3xl text-black">
          Welcome to Dashboard!
        </h3>
      </div>
      <DashboardCards />
    </div>
  );
}
